import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
  Messaging,
} from "firebase/messaging";
import {
  getAuth,
  GoogleAuthProvider,
} from "firebase/auth";
import { REACT_APP_NOTIFICATION_VAPID_KEY } from "../constants/config";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const isFirebaseSupported = async () => {
  try {
    const isFirebaseSupported = await isSupported();
    return isFirebaseSupported;
  } catch (error) {
    console.error("Firebase is not supported:", error);
    return false;
  }
};

// Get FCM token
export const getFCMToken = async (
  messaging: Messaging
): Promise<string | null> => {
  try {
    const isSupported = await isFirebaseSupported();
    if (!isSupported) {
      console.error("Firebase is not supported in this environment.");
      return null;
    }

    // Check if permission is granted
    if (Notification.permission === 'granted') {
      console.log('Permission already granted.');
      // Safe to proceed
    } else if (Notification.permission === 'denied') {
      console.error('Notification permission previously denied.');
      return null; // Don't ask again
    } else {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.error('Notification permission denied.');
        return null;
      }
      console.log('Permission granted after request.');
    }

    // Get the FCM token
    const token = await getToken(messaging, {
      vapidKey: REACT_APP_NOTIFICATION_VAPID_KEY,
    });

    if (token) {
      localStorage.setItem("fcmToken", token); // Store token in local storage
      return token;
    } else {
      console.error("No FCM token available.");
      return null;
    }
  } catch (error) {
    console.error("Error generating FCM token:", error);
    return null;
  }
};

// Listen for incoming messages
export const onMessageListener = () => {
  const messaging = getMessaging(app);
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};
export const messaging = getMessaging(app);